import { Outlet, useNavigate } from "react-router-dom";
import { Button, Col, Row } from "react-bootstrap";

export default function AdminLayout() {
  const navigate = useNavigate();

  return (
    <Row className="min-vh-100">
      <Col md={2} className="bg-success text-white p-4">
        <h4 className="fw-bold mb-4">NIVARA ADMIN</h4>

        <div className="d-grid gap-3">
          <Button variant="outline-light" onClick={() => navigate("/admin/dashboard")}>
            Dashboard
          </Button>
          <Button variant="outline-light" onClick={() => navigate("/admin/manage-rooms")}>
            Rooms
          </Button>
          <Button variant="outline-light" onClick={() => navigate("/admin/bookings")}>
            Bookings
          </Button>
          <Button
            variant="outline-warning"
            onClick={() => {
              localStorage.clear();
              navigate("/login");
            }}
          >
            Logout
          </Button>
        </div>
      </Col>

      <Col md={10} className="p-4">
        <Outlet />
      </Col>
    </Row>
  );
}
